import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import UserService from "services/User";
import { PRODUCT_LINES_TABLE_CONSTANTS } from "routes/product_line/product_lines_table/ProductLinesTableV3";
import ProductLineService from "services/ProductLine";
import { getProductLinesTableColumns } from "routes/product_line/product_lines_table/ProductLinesTableColumnsAndFilters";
import { addResizedColumns } from "./useTableConfig";

export const invalidateProductLinesQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [PRODUCT_LINES_TABLE_CONSTANTS.queryKey],
  });
};

export const deleteProductLine = async id => {
  await ProductLineService.delete(id);
  await invalidateProductLinesQuery();
};

export const useProductLinesTable = () => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getProductLinesTableColumns();
    const productLinesTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${PRODUCT_LINES_TABLE_CONSTANTS.tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: productLinesTableSettings?.resized_columns || {},
    });
    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched]);

  return { columns };
};
